import { Component, Input, OnDestroy } from "@angular/core";
import { IdService } from "../shared/services/id.service";


@Component({
	selector: "rbc-badge",
	template: `
		<div [id]="id" class="rbc-badge">
			<ng-content></ng-content>
			<div class="rbc-badge-text" [ngClass]="classGen()">
				{{ text }}
				<span *ngIf="label" class="sr-only" [id]="id + 'SRLabel'">
					{{ label }}
				</span>
			</div>
		</div>
	`,
	styles: []
})
export class BadgeComponent implements OnDestroy {
	@Input() id: string;
	@Input() label: string;
	@Input() text: string | number = 0;
	@Input() positionX: "left" | "right" = "right";
	@Input() pinned = true;

	constructor(private idService: IdService) {
		this.id = this.idService.generate();
	}

	ngOnDestroy(): void {
		if (this.idService) {
			this.idService.remove(this.id);
		}
	}

	classGen(){
		let classes = {};
		classes["rbc-badge-"+ this.positionX] = this.positionX;
		classes["rbc-badge-pinned"] = this.pinned;
		return classes;
	}
}
